import TaskRecord from './TaskRecord';

class WordListDelayedRecallTaskList extends TaskRecord {

    constructor() {
        super()
        this.taskType = 'WordListDelayedRecall'
    }
    
    parseLogExtra(logJson) {
        if (!logJson) return
        if (!logJson['Summary']) return
        this.fileName = logJson['Summary']['RecordingFilename']
    }

    //--
}

export default WordListDelayedRecallTaskList;